import { Api } from '@/src/store/api'

export const MortgageApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /mortgage/leads/scheduled-calls': {
      invalidatesTags: ['GET /mortgage/leads/scheduled-calls'],
    },
  },
})
